import React from 'react';

const Loading = () => {
    return (
      <div className="flex items-center justify-center ">
        <div className="w-16 h-16 mt-36 border-4 border-dashed rounded-full animate-spin  border-violet-700"></div>
      </div>
    );
};

export default Loading;